import { Edit, Image } from '@mui/icons-material'
import { Box, Icon, Typography } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import AvatarWithLoader from 'components/avatar-with-loader'
import IncidentReportActionButton from 'components/incident-reports/incident-report-action-button'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserAdminOperations,
  operations as userAdminOperations
} from 'states/dux/user-admin/operations'
import { Payload as UserAdminPayload } from 'states/dux/user-admin/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { IncidentReport } from 'types/incident-report'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
  userAdmin: UserAdminPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
    userAdmin: UserAdminOperations
  }
}

interface OwnProps {
  reportDetails: IncidentReport
  onClickEvent: (report: IncidentReport) => void
}

type AppProps = StateProps & DispatchProps & OwnProps

const ReportAdminCardFC: React.FC<any> = (props: AppProps) => {
  const { theme, reportDetails } = props
  const [hovered, setHovered] = React.useState(false)
  return (
    <Box
      border={1}
      borderRadius={8}
      borderColor={theme.secondaryColor}
      padding={2}
      margin={2}
      width={240}
    >
      <Box
        margin={'auto'}
        paddingY={2}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        sx={{ cursor: 'pointer' }}
        onClick={() => props.onClickEvent(reportDetails)}
      >
        {hovered && (
          <Box position={'relative'} height={'1px'} width={'1px'} zIndex={20}>
            <Icon
              style={{
                marginTop: '85px',
                marginLeft: '-20px',
                fontSize: '50px'
              }}
            >
              <Edit fontSize={'inherit'} />
            </Icon>
          </Box>
        )}
        {reportDetails.images.length > 0 && (
          <AvatarWithLoader
            LoaderIcon={Image}
            src={reportDetails.images[0].url}
            avatarProps={{
              sx: {
                height: 220,
                width: 220,
                transition: '0.5s',
                borderRadius: hovered ? 16 : 2
              }
            }}
          />
        )}
        {reportDetails.images.length === 0 && (
          <AvatarWithLoader
            src={''}
            avatarProps={{
              sx: {
                height: 220,
                width: 220,
                transition: '0.5s',
                borderRadius: hovered ? 16 : 2
              }
            }}
          />
        )}
      </Box>
      <Box>
        <Typography
          variant={'h5'}
          sx={{
            overflow: 'hidden !important',
            whiteSpace: 'nowrap !important',
            textOverflow: 'ellipsis'
          }}
        >
          {reportDetails.title}
        </Typography>
        <Typography>
          {reportDetails.createdBy.fullName} | {reportDetails.status}
        </Typography>
        <Box
          width={1}
          borderBottom={1}
          borderColor={theme.secondaryColor}
          marginY={1}
          marginBottom={2}
        />
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          height={20}
        >
          <IncidentReportActionButton
            report={reportDetails}
            useIconButton={true}
          />
        </Box>
      </Box>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user,
    userAdmin: state.userAdmin
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations,
  userAdmin: userAdminOperations
})

const ReportAdminReportCard = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportAdminCardFC) as React.FC<OwnProps>

export default ReportAdminReportCard
